import { FC } from "react"
import { useDLMResponseFormContext } from "../../components/DLMResponseFormContext"
import { IDLMWebDOCModel } from "../../../../../core/doclabel"

type Props = {
    index: number
    onGenDOC: Function
    baseData: IDLMWebDOCModel
    hasIssueDate?: boolean

}

const DLMGenerateDOCButton: FC<Props> = ({index, onGenDOC, baseData, hasIssueDate = false}) => {
    
    const { setBaseDOC, setGenDOCIndex, setOnGenDOC, generateDOC } = useDLMResponseFormContext();    
    
    return(
    <button
        type="button"
        className='btn btn-sm btn-light-secondary py-1 mb-1 px-3'
        onClick={() => {
            setBaseDOC(baseData);
            setGenDOCIndex(index);
            setOnGenDOC(() => onGenDOC);
            generateDOC(hasIssueDate);            
        }}        
    >
        <span className='indicator-label'>Generate DOC</span>        
    </button>
    )
}

export {DLMGenerateDOCButton}